export default __webpack_public_path__ + "static/media/sendButtonDisabled.94316b03.svg";